import { FC, useRef, useState } from "react";
import classNames from "classnames";
import useClickOutside from "hooks/useClickOutside";
import useTranslate from "hooks/useTranslate";
import QuestionIcon from "assets/icons/loyalty/question.svg?react";
import { IconTriangle } from "./IconTriangle";
import "./styles.sass";

type LoyaltyTooltipProps = {
  title: string;
  text: string;
};

const LoyaltyTooltip: FC<LoyaltyTooltipProps> = ({ title, text }) => {
  const t = useTranslate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const handleClose = () => setOpen(false);
  const handleToggle = () => setOpen((prevState) => !prevState);
  useClickOutside({ refs: [ref], handler: handleClose });

  const classNameTooltip = classNames(
    "LoyaltyTooltipInfo__tooltip",
    open && "LoyaltyTooltipInfo__tooltip_open",
  );

  return (
    <div className="LoyaltyTooltipInfo" ref={ref}>
      <QuestionIcon
        onClick={handleToggle}
        className="LoyaltyTooltipInfo__iconQuestion"
      />
      <div className={classNameTooltip}>
        <IconTriangle className="LoyaltyTooltipInfo__iconTriangle" />
        <span className="LoyaltyTooltipInfo__title">{t(title)}</span>
        <p className="LoyaltyTooltipInfo__description">{t(text)}</p>
      </div>
    </div>
  );
};

export default LoyaltyTooltip;
